var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (articles) {
buf.push("<div class=\"articles-feed-articles js-articles-feed-articles\"></div><div class=\"js-articles-feed-more articles-feed-more-button\">");
if ( articles.length && !(articles.length >= articles.count))
{
buf.push("<button class=\"avant-garde-button-white is-block js-load-more-articles\">More Articles" + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)));
if ( articles.count)
{
buf.push("(" + (jade.escape((jade_interp = articles.count - articles.length) == null ? '' : jade_interp)) + ")");
}
buf.push("</button>");
}
buf.push("</div>");}.call(this,"articles" in locals_for_with?locals_for_with.articles:typeof articles!=="undefined"?articles:undefined));;return buf.join("");
};
module.exports = template;